import React from "react";
import FinancialBox from "../../components/boxes/FinancialBox";
import Configurer from "../../components/Configurer";
import DataGrid from "../../components/DataGrid";
import NumberInput from "../../components/inputs/NumberInput";
import TLink from "../../components/TLink";
import { translate } from "../../utils/useful";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import HttpServices from "../../utils/Http.services";
import Loader from 'react-loader-spinner'

class Wallet extends React.Component {

    state = {

        isLoadingPost: false,
        data: [
            // { name: '$12', description: 'This is the description',type:'income' },
            // { name: '$120', description: 'This is the description',type:'income' },
            // { name: '$20', description: 'Charged your wallet',type:'charge' },
            // { name: '$100', description: 'This is the description',type:'charge' },

        ],
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.setState({ amount: Number(value) })
        }
    }


    increaseBalance = () => {

        if (this.state.amount && this.state.amount >= 0 && this.state.amount != '') {
            this.setState({ isLoadingPost: true })
            HttpServices.request("increaseBalance", { amount: this.state.amount }, (fetchResult, fetchError) => {

                this.setState({ isLoadingPost: false })

                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                if (fetchResult.user) {
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccessfully', description: '{{lang}}info.postSuccessfullyDesc' })
                    this.props.actions.setUser(fetchResult.user, null, true)
                    this.setState({ amount: '' })
                }

            })
        } else {
        }
    }


    render() {
        return (

            <Configurer
                settingsInfo={{ headerTitle: "Account Type", button: { goBack: true } }}
                title={"Account Type"}
                description={"This is the Account Type"}
                className=""
                changeOnUnmount={true}
            // parentConfigure={this.props.parentConfigure??null}
            >
                <div className="px-3" style={{ backgroundColor: '#f2f6f8' }}>
                    <div style={{ padding: '3% 5%', minHeight: '110vh' }}>
                        <div className="px-2 pt-4" >


                            <div className="flexcb w-100">
                                <div className="w-100">
                                    <p className="text-ultra-big font-bold">{translate("Wallet")}</p>
                                </div>
                                <button onClick={() => this.props.openMobileMenu()} className="flexcc d-md-none " style={{ flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                                </button>
                            </div>

                            {/* <p className="text-small" style={{ color: '#9ab' }}>{this.props.user?.info?.fullname}</p> */}
                        </div>




                        <div className="d-flex w-100 mt-3 mb-4" style={{ alignItems: 'stretch', flex: 1 }} >
                            <div className="text-center  w-100 mx-2 px-5 py-4  flexcc flex-column" style={{ backgroundColor: '#677dc430' }}>
                                <p className="text-bold text-big" style={{ color: '#677dc4' }}>{this.props.user?.info?.balance ?? 0} Toman</p>
                                <p className="text-normal  text-bold " style={{ color: '#345' }}>Your total Balance</p>
                                <p className="text-smaller  " style={{ color: '#345' }}>This balance shows the credit you can use for using all services</p>

                            </div>

                            <div className="text-center  w-100 mx-2 px-5 py-4  flexcc flex-column" style={{ backgroundColor: '#677dc430' }}>
                                <p className="text-bold text-big" style={{ color: '#677dc4' }}>{this.props.user?.info?.selfBalance ?? 0} Toman</p>
                                <p className="text-normal  text-bold " style={{ color: '#345' }}>Your personal Balance</p>
                                <p className="text-smaller  " style={{ color: '#345' }}>This balance shows the credit you can use for using you own things. You can enjoy our <TLink to={'/pages/free_service'} style={{ color: '#677dc4' }}>free services</TLink></p>
                            </div>

                        </div>



                        <div className="text-center  w-100 mx-2 mt-3 px-5 py-4 flexcc flex-column " style={{ borderTop: '1px solid #677dc430', borderBottom: '0px solid #677dc430' }}>
                            <p className="text-bold text-big mb-2 " style={{ color: '#677dc4' }}>Inclease balance</p>


                            <input pattern="[0-9]*" value={this.state.amount != null ? this.state.amount : ''} onChange={(e) => this.changeInputValue(e.target)} className="text-bold text-center" placeholder="Amount ..." style={{ backgroundColor: '#fff', borderRadius: 4, border: '1px solid #677dc4', fontSize: 20, color: '#677dc4', padding: '10px 20px' }} />
                            {this.state.isLoadingPost ? (
                                <div className="p-2 text-center">
                                    <Loader
                                        type="Oval"
                                        color="#677dc4"
                                        height="40"
                                        width="40"
                                    />
                                </div>
                            ) : (
                                <button onClick={() => this.increaseBalance()} className="text-semibig mt-2" style={{ backgroundColor: '#677dc4', color: '#fff', border: '0px solid #fff', borderRadius: 4, padding: '8px 20px' }}>
                                    <p className="text-bold">DO PAYMENT</p>
                                </button>
                            )}

                            {this.props.user?.info?.balance < 0 && (
                                <div>
                                    <p className="mt-2 text-small" style={{ color: '#ee5050' }}>You need to increase you balance as much to compensate the negative credit, or</p>
                                    <button className="mt-2" style={{ backgroundColor: '#ee5050', borderRadius: 4, color: '#fff', padding: '4px 15px' }}>Ignore negative credit, and lose data</button>
                                </div>
                            )}

                            {/* <p className="text-smaller  mt-2" style={{ color: '#345' }}>More description about payment can be shown here</p> */}
                        </div>





                    </div>





                </div>

            </Configurer >
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Wallet);

